
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import {
    CircularProgress,
    FormControl,
    Select,
    MenuItem,
    FormHelperText,
    InputLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    CardMedia,
    Paper,
} from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { validateSignUpData } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import {
    ROLE_PROVIDER,
    getCountryCode,
    countries,
    SERVER_URL
} from '../../utils/config/constants';
import Verification from '../Providers/Verification';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { cookies } from '../../utils/getToken';

class ProviderSignup extends Component {
    constructor(props) {
        super(props);
        console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww", props)

        this.state = {
            loaderButton: false,
            showChangePhone: false,
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            value: 0,
            businessName: '',
            firstNameError: '',
            lastNameError: '',
            businessCategoryError: '',
            referalError: '',
            phone: '',
            referal_code: '',
            countryCode: '1',
            isPhoneClose: false,
            isEmailClose: false,
            isDialogOpen: false,
            isDialogClose: false,
            redirect: false,
            accountType: "2",
            hideGetOtp: false,
            hideLogin: true,
            hideExtraField: true,
            showVerifyBtn: false,
            dashboardRedirect: false,
            categoryData: [{
                key: "5ff6259dfb0857441a7831db",
                heading: "Select Business Category *"
            }],
            business_category: "5ff6259dfb0857441a7831db",
            hideBusinessName: false,
            okay: "",
            otp_agree: 0,
            otpAgreeError: false
        };
    }

    componentDidUpdate() {
        if (this.state.timer === 0) {
            clearInterval(this.time)
        }

    }
    componentDidMount() {

        axios({
            method: 'get',
            url: `${SERVER_URL}/mastercategory/newlist`,
            // url: `${SERVER_URL}/admin/mastercategory/list`
        }).then(resJson => {
            this.setState({
                categoryData: [...this.state.categoryData, ...resJson.data.data],
            })
            console.log("94 RES CATEGORY DATA", resJson);

        })
        console.log("93 PROVIDER SIGNUP CATEGORY DATA", this.state.categoryData);
    }
    componentWillUnmount() {
        clearInterval(this.time)
    }

    handleClose = () => {
        this.props.closeLoginPopup();
    };
    handleVerifyClose = () => {
        this.setState({ isDialogOpen: false });
    };

    renderSignupButton = () => {
        const { loaderButton } = this.state;
        if (loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <a
                    style={{ width: "100%" }}
                    href="javascript:void(0)"
                    className="custom-button"
                    onClick={this.signupActionCall}
                >
                    REGISTER
                </a>
            );
        }
    };

    signupActionCall = () => {
        console.log("signupActionCall")
        if (this.state.email == "" || this.state.firstName == "" || this.state.lastName == "" || this.state.business_category == '5ff6259dfb0857441a7831db' || this.state.businessName == "") {
            if (this.state.email == "") {
                this.setState({ emailError: "Email field required!" });
            }
            if (this.state.firstName == "") {
                this.setState({ firstNameError: "First Name field required!" });

            }
            if (this.state.lastName == "") {
                this.setState({ lastNameError: "Last Name field required!" });

            }
            if (this.state.businessName == "") {
                this.setState({ businessNameError: "Business name field required!" });

            }
            if (this.state.business_category == '5ff6259dfb0857441a7831db') {
                NotificationManager.error("Business category field required!",);
                this.setState({ businessCategoryError: "Business category field required!" });
            }
        } else {
            this.setState({ loaderButton: true });

            this.props.signupAction(
                {
                    primary_business: this.state.business_category,
                    name: `${this.state.firstName} ${this.state.lastName}`,
                    businessName: this.state.businessName,
                    email: this.state.email,
                    otp: this.state.password,
                    provider_type: this.state.accountType,
                    phone: this.state.phone,
                    countryCode: this.state.countryCode,
                    role: ROLE_PROVIDER,
                    referral_code: this.state.referal_code
                },
                this.onDone
            );
        }

    };
    handleError = params => {
        this.setState(params);
    };

    onDone = (success, data) => {

        if (success) {
            if (!cookies.get('x-auth-token', { path: '/' })) {
                console.log("working test")
                cookies.set('x-auth-token', data.token, { path: '/' });
            }
            cookies.set('x-auth-token', data.token, { path: '/' });
            this.setState({
                loaderButton: false,
                dashboardRedirect: true
            });
            this.props.history.push({ pathname: `/user/profile/initial` });
            // this.props.history.push({ pathname: `/user/profile` });

        } else {
            this.setState({
                loaderButton: false,
                referalError: data
            });
        }
    };

    handleError = params => {
        this.setState(params);
    };
    handleCountryChange = event => {
        console.log({ event });
        this.setState({
            [event.target.name]: event.target.value,
            countryCodeError: ''
        });
    };

    handleChangeAccountType = (value) => {

        if (value == 2) {
            this.setState({
                accountType: 2,
                hideBusinessName: false
            })
        } else {
            this.setState({
                accountType: 1,
                hideBusinessName: true
            })
        }

    }

    renderGetOtpButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button
                    disabled={this.state.otpAgreeError ? true : false}
                    className="custom-button"
                    onClick={() => this.getOptCall()}
                >
                    GET ONE TIME PASSWORD
                </button>
            );
        }
    };

    renderVerifyOtpButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button
                    className="custom-button"

                    onClick={() => this.getVerifyOptCall()}
                >
                    VERIFY ONE TIME PASSWORD
                </button>
            );
        }
    }

    getVerifyOptCall = () => {
        this.setState({ loaderButton: true });
        axios({
            method: 'post',
            url: `${SERVER_URL}/otp/verify`,
            data: {
                country_code: this.state.countryCode,
                phone: this.state.phone,
                otp: this.state.password
            },
        }).then(resJson => {
            console.log("Adahvs a s a sjhasca:::", resJson)
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({ okay: resJson.data.message })
                this.setState({
                    loaderButton: false,
                    hideLogin: false,
                    hideExtraField: false,
                    showVerifyBtn: false
                })
            } else {
                this.setState({
                    loaderButton: false,
                    passwordError: resJson.data.message
                })
            }
        })
    }
    getOptCall = () => {
        if (this.state.otp_agree === 0) {
            this.setState({ otpAgreeError: true })
        } else {
            this.setState({ otpAgreeError: false })
            if (this.state.phone.length != 10 & this.state.phone.length != 0) {
                this.setState({
                    phoneError: "phone length should be 10 *"
                })
            } else {
                this.setState({ loaderButton: true, timer: 90, showChangePhone: true });
                axios({
                    method: 'post',
                    url: `${SERVER_URL}/otp/generate`,
                    data: {
                        country_code: this.state.countryCode,
                        phone: this.state.phone,
                        role: ROLE_PROVIDER
                    },
                }).then(resJson => {
                    console.log("Adahvs a s a sjhasca:::", resJson)
                    if (resJson.data.status == "OK") {
                        NotificationManager.success("Success", resJson.data.message)
                        this.time = setInterval(() => {
                            this.setState((prevState => ({
                                timer: prevState.timer - 1
                            })))
                        }, 1000)
                        this.setState({
                            loaderButton: false,
                            hideGetOtp: true,
                            hideExtraField: false,
                            showVerifyBtn: true,
                            password: "",
                            passwordError: "",
                            error: ""

                        })
                    } else {
                        NotificationManager.error("Oops!", resJson.data.message)
                        this.setState({
                            loaderButton: false,
                            password: "",
                            passwordError: "",
                            error: ""
                        })
                    }
                })
            }
        }
    }

    handleBusinessCategory = event => {
        this.setState({
            business_category: event.target.value,
            businessCategoryError: event.target.value == '5ff6259dfb0857441a7831db' ? 'Business category field required!' : ''
        })
    }

    handleOtpAgree = event => {
        this.setState({ otp_agree: event.target.value, otpAgreeError: false })

    };

    render() {

        console.log("Colorssss:::::", this.props.colors)
        const {
            passwordError,
            emailError,
            businessNameError,
            firstNameError,
            lastNameError,
            businessCategoryError,
            phoneError,
            isDialogOpen,
            otpError,
            countryCodeError,
            hideLogin,
            loaderButton,
            showChangePhone,
            hideBusinessName,
            referalError

        } = this.state;
        const { formatMessage } = this.props.intl;
        if (this.state.dashboardRedirect) {
            NotificationManager.success(
                <FormattedMessage id="Welcome" defaultMessage="Welcome" />,
                'Success'
            );
            this.props.history.push(`/user/profile/initial`);
            //  this.props.history.push(`/user/dashboard`);

        }
        return (
            <div>
                <form className="form-new" autoComplete="false">
                    <div className="dialog-body">

                        <div className="row">
                            {(this.state.hideExtraField || this.state.showVerifyBtn) && <React.Fragment>
                                <div className="col-md-12 mb-2" style={{ marginTop: 10 }}>
                                    <TextField
                                        style={{ borderTopWidth: 1, borderTopColor: this.props.colors.SECONDARY.HEX }}
                                        error={phoneError ? true : false}
                                        helperText={phoneError}
                                        className="login-form-textfield"
                                        label={formatMessage({
                                            id: 'phone'
                                        })}
                                        id="phone"
                                        pattern="[0-9]*"
                                        fullWidth={true}
                                        name="phone"
                                        type="number"
                                        placeholder="Enter Mobile"
                                        value={this.state.phone}
                                        onChange={e => {
                                            const re = /^[0-9\b]+$/;
                                            if (e.target.value === '' || re.test(e.target.value) && e.target.value.length <= 10) {
                                                this.setState({
                                                    phone: e.target.value,
                                                    phoneError: "",
                                                })
                                            }
                                        }}
                                        disabled={this.state.loaderButton || this.state.showVerifyBtn || !this.state.hideExtraField}
                                        margin="normal"
                                    />
                                    {this.state.showChangePhone && (
                                        <a className="mb-2" style={{ justifyContent: "flex-end", display: "flex" }} href="javascript:void(0);">
                                            <p style={{
                                                fontWeight: "normal",
                                                ":hover": {
                                                    fontWeight: "bold",
                                                }
                                            }}
                                                onClick={() => {
                                                    this.setState({
                                                        hideGetOtp: false,
                                                        hideLogin: true,
                                                        hideExtraField: true,
                                                        showVerifyBtn: false,
                                                        showChangePhone: false,
                                                        timer: 0
                                                    })
                                                }}>
                                                Change Phone
                                            </p>
                                        </a>
                                    )}
                                </div>
                            </React.Fragment>}




                        </div>
                        {
                            this.state.otpAgreeError
                                ? <p style={{ color: 'red', fontSize: 17, marginLeft: 47, marginTop: 10 }}>Please agree to recieve text messages from ezPro</p>
                                : null
                        }


                        {this.state.hideGetOtp && (this.state.hideExtraField || this.state.showVerifyBtn) &&
                            <div className="input-field s12" style={{ marginTop: -20, display: "flex", flexDirection: "column" }}>
                                <TextField
                                    error={passwordError ? true : false}
                                    helperText={passwordError}
                                    className="login-form-textfield"
                                    label={"One Time Password"}
                                    id="password"
                                    type="number"
                                    placeholder="Enter One Time Password"
                                    fullWidth={true}
                                    name="OTP"
                                    value={this.state.password}
                                    onChange={event => {
                                        const re = /^[0-9\b]+$/;
                                        if (event.target.value === '' || re.test(event.target.value) && event.target.value.length <= 8) {
                                            this.setState({
                                                password: event.target.value,
                                                passwordError: '',
                                                error: ""
                                            });
                                        }

                                    }}
                                    disabled={loaderButton}
                                    margin="normal"
                                />



                                {this.state.okay ? null :
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "end"
                                    }}>
                                        <div className="input-field s12">
                                            {!this.state.timer == 0 ? <a href="javascript:void(0);">
                                                <p >
                                                    Resend One Time Password in&nbsp;
                                                    <span style={{
                                                        fontWeight: "bold",
                                                        color: "#0078ff"
                                                    }}>
                                                        0:{this.state.timer}
                                                    </span>
                                                </p>
                                            </a> : <a href="javascript:void(0);">
                                                <p onClick={() => {
                                                    this.getOptCall()
                                                }}>
                                                    Resend One Time Password
                                                </p>
                                            </a>}
                                        </div>
                                    </div>
                                }
                            </div>

                        }


                        {!this.state.hideExtraField && !this.state.showVerifyBtn &&
                            <div className="col-md-12">
                                <FormControl
                                    className={
                                        'login-form-textfield phone-field'
                                    }
                                    error={countryCodeError ? true : false}

                                >
                                    <Select style={{}}
                                        className="login-form-textfield form-control"
                                        // autoWidth={true}
                                        value={this.state.business_category}
                                        onChange={this.handleBusinessCategory}
                                        label="Select Business Category"
                                    >
                                        {this.state.categoryData.map((category, index) => {
                                            console.log("645 MAP Category data", this.state.categoryData);
                                            return (
                                                <MenuItem
                                                    value={category.key}
                                                    key={index}
                                                >
                                                    {category.heading}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                                {businessCategoryError && <p style={{ fontSize: '14px', color: '#f44336', mt: 1 }}>{businessCategoryError}</p>}
                            </div>

                        }

                        {!this.state.hideExtraField && !this.state.showVerifyBtn && !hideBusinessName &&
                            < TextField
                                error={businessNameError ? true : false}
                                helperText={businessNameError}
                                className="login-form-textfield"
                                label={formatMessage({
                                    id: 'businessName *'
                                })}
                                id="businessName"
                                fullWidth={true}
                                name="businessName"
                                type="businessName"
                                placeholder="Enter Business Name"
                                value={this.state.businessName}
                                onChange={event => {
                                    this.setState({
                                        businessName: event.target.value,
                                        businessNameError: ''
                                    });
                                }}
                                disabled={this.state.loaderButton}
                                margin="normal"
                            />}
                        {!this.state.hideExtraField && !this.state.showVerifyBtn &&
                            <TextField
                                error={firstNameError ? true : false}
                                helperText={firstNameError}
                                className="login-form-textfield"
                                label={
                                    formatMessage({
                                        id: "First Name *"
                                    })
                                }
                                id="firstName"
                                fullWidth={true}
                                name="firstName"
                                type="firstName"
                                placeholder="First Name"
                                value={this.state.firstName}
                                onChange={event => {
                                    this.setState({
                                        firstName: event.target.value,
                                        firstNameError: '',
                                        error: ""
                                    });
                                }}
                                disabled={this.state.loaderButton}
                                margin="normal"
                            />}
                        {!this.state.hideExtraField && !this.state.showVerifyBtn &&
                            <TextField
                                error={lastNameError ? true : false}
                                helperText={lastNameError}
                                className="login-form-textfield"
                                label={
                                    formatMessage({
                                        id: "Last Name *"
                                    })
                                }
                                id="lastName"
                                fullWidth={true}
                                name="lastName"
                                type="lastName"
                                placeholder="Last Name"
                                value={this.state.lastName}
                                onChange={event => {
                                    this.setState({
                                        lastName: event.target.value,
                                        lastNameError: '',
                                        error: ""
                                    });
                                }}
                                disabled={this.state.loaderButton}
                                margin="normal"
                            />}
                        {!this.state.hideExtraField && !this.state.showVerifyBtn &&
                            <TextField
                                error={emailError ? true : false}
                                helperText={emailError}
                                className="login-form-textfield"
                                label={formatMessage({
                                    id: 'email *'
                                })}
                                id="email"
                                fullWidth={true}
                                name="email"
                                type="email"
                                placeholder="Email"
                                value={this.state.email}
                                onChange={event => {
                                    this.setState({
                                        email: event.target.value,
                                        emailError: '',
                                        error: ""
                                    });
                                }}
                                disabled={this.state.loaderButton}
                                margin="normal"
                            />}

                        {!this.state.hideExtraField && !this.state.showVerifyBtn &&
                            <TextField
                                style={{ borderTopWidth: 1, borderTopColor: this.props.colors.SECONDARY.HEX }}
                                error={phoneError ? true : false}
                                helperText={phoneError}
                                className="login-form-textfield"
                                label={formatMessage({
                                    id: 'phone'
                                })}
                                id="phone"
                                pattern="[0-9]*"
                                fullWidth={true}
                                name="phone"
                                type="number"
                                placeholder="Enter Mobile"
                                value={this.state.phone}
                                onChange={e => {
                                    const re = /^[0-9\b]+$/;
                                    if (e.target.value === '' || re.test(e.target.value) && e.target.value.length <= 10) {
                                        this.setState({
                                            phone: e.target.value,
                                            phoneError: "",
                                        })
                                    }
                                }}
                                disabled={this.state.loaderButton || this.state.showVerifyBtn || !this.state.hideExtraField}
                                margin="normal"
                            />
                        }


                        {!this.state.hideExtraField && !this.state.showVerifyBtn &&
                            <TextField
                                className="login-form-textfield"
                                label="Referral Code"
                                error={referalError ? true : false}
                                helperText={referalError}
                                fullWidth={true}
                                id='referal'
                                name="referal"
                                type="text"
                                value={this.state.referal_code}
                                onChange={event => {
                                    this.setState({
                                        referal_code: event.target.value,
                                    });
                                }}
                                placeholder="Enter Referal"
                                disabled={this.state.loaderButton}
                                margin="normal"
                            />
                        }

                        {
                            <div

                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    marginTop: '10px'
                                    // marginTop: 45
                                    // justifyContent: 'center',
                                }}>
                                <Radio
                                    className="checked-radio"
                                    checked={
                                        this.state.otp_agree == 1
                                    }
                                    onChange={event => this.handleOtpAgree(event)}
                                    // onChange={this.handlePaymentOption}
                                    value="1"
                                    color="primary"
                                    style={{}}
                                /><p style={{
                                    fontSize: 15
                                }}>I agree to receive text messages from ezPro (+1 8882903499)</p>
                            </div>
                        }
                        {!this.state.hideGetOtp &&
                            <div className="d-flex justify-content-center md-12">
                                {this.renderGetOtpButton()}
                            </div>}
                        {this.state.showVerifyBtn &&
                            <div className="d-flex justify-content-center md-12 mt-3">
                                {this.renderVerifyOtpButton()}
                            </div>}

                        {
                            !hideLogin && !this.state.showVerifyBtn &&
                            <div
                                className="d-flex align-items-center justify-content-center md-12"
                            >
                                {this.renderSignupButton()}
                            </div>
                        }
                        {/* {!hideLogin && !this.state.showVerifyBtn && <div className="d-flex align-items-center ">
                       
                        </div>} */}
                    </div>
                </form>


                {isDialogOpen && (
                    <Verification
                        email={this.state.email}
                        open={this.state.isDialogOpen}
                        close={this.handleVerifyClose}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ settings }) => {
    return {
        colors: settings.colors
    };
};


const composedComponent = compose(withTheme(), connect(mapStateToProps, actions));
export default composedComponent(injectIntl(withRouter(ProviderSignup)));


// WEBPACK FOOTER //
// ./src/components/Customer/ProviderSignup.jsx